module.exports = __webpack_public_path__ + "static/media/project_management.f4a56233.png";